export default function parseTextFromJson(jsonData) {
    const blocks = JSON.parse(jsonData);
    let text = "";
    blocks.document.nodes.forEach((block) => {
        if (block.type === "image") {
            text += `<p>
                        <img src=${block.data.url} width=${block.data.width} height=${block.data.width} title=${block.data.title} alt=${block.data.title}>
                    </p>`;
        } else if (block.type === "paragraph") {
            block.nodes.forEach((node) => {
                text += `<p>${node.leaves[0].text}</p>`;
            });
        }
    });
    return text;
}
